import { all, call, put, take, select } from 'redux-saga/effects';
import { GET_TOC } from './actions';
import { SAVE_TOC } from 'Reducers/dataModels';
import { notifications, GET_TOC_FAIL } from 'PipeRouter';
import { getTOC as vsGetTOC } from 'Services/learnkit';


function* getTOC() {
  yield take(GET_TOC);

  logger.info('GET_TOC');

  try {
    const { toc } = yield call(vsGetTOC);
    if (!toc || toc.length === 0) {
      throw "no vital source toc information found";
    } else {
      yield put({ type: SAVE_TOC, data: toc });

      logger.info('GET_TOC_SUCCEEDED');
    }
  } catch (err) {
    logger.error('GET_TOC_FAIL', { err });
    yield put(notifications(GET_TOC_FAIL));
  }
}


export default getTOC;
